import axios from "axios";
import { createContext, useEffect, useState } from "react";

axios.defaults.baseURL = "/api"

// Tokens from older versions are no longer used.
sessionStorage.removeItem("user_token");

// The session cookie is HttpOnly (scripts cannot read it). The server also requires this
// page key, which lives only in memory: reloading or closing the page means logging in again.
let pageKey = null;
let onSessionEnded = () => {};

axios.interceptors.request.use((config) => {
  if (pageKey) config.headers["x-page-key"] = pageKey;
  return config;
});

// Expired or rejected session: back to the login screen.
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401 && pageKey) {
      pageKey = null;
      onSessionEnded();
    }
    return Promise.reject(error);
  }
);

export const AuthContext = createContext();

export const AuthContexProvider = ({ children }) => {

  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    onSessionEnded = () => setCurrentUser(null);
  }, []);

  const login = async (inputs) => {
    const res = await axios.post("/auth/login", inputs);
    pageKey = res.data.key;
    setCurrentUser(pageKey);
  };

  return (
    <AuthContext.Provider value={{ currentUser, login }}>
      {children}
    </AuthContext.Provider>
  );

};
